import React from 'react'
import {
  getCookieStatus,
  CookieSettingsState,
} from './cookiebar.utils.mod'

export interface CookieSensitiveContentWrapperProps {
  children: React.ReactNode
  placeholder: React.ReactNode
  groupId?: number
  button?: string
  options: { style?: CookieSensitiveContentWrapperStyle; key?: string }
}

export type CookieSensitiveContentWrapperStyle = Partial<{
  cookies_classname: string
  cookies_inner_classname: string
  cookies_text_classname: string
  cookies_clickable_classname: string
}>

export class CookieSensitiveContentWrapper extends React.Component<
  CookieSensitiveContentWrapperProps,
  CookieSettingsState
> {
  constructor(props: CookieSensitiveContentWrapperProps) {
    super(props)

    this.state = {
      error: false,
      cookieStatus: getCookieStatus(this.props.groupId),
      unsubListener: () => {}
    }

    this.handleCookieEvent = this.handleCookieEvent.bind(this)
  }

  handleCookieEvent() {
    this.setState({ error: false, cookieStatus: getCookieStatus(this.props.groupId) });
  }

  componentDidMount() {
    window.addEventListener("FCCookiesUpdated", this.handleCookieEvent);
  }

  componentWillUnmount() {
    window.removeEventListener("FCCookiesUpdated", this.handleCookieEvent);
  }

  componentDidCatch() {
    this.setState({ error: true })
  }

  render() {
    if (this.state.error) {
      return (
        <div className={`error ${this.props.options.style.cookies_classname ? this.props.options.style.cookies_classname : 'text-center bg-light'}`}>
          <div className={this.props.options.style.cookies_inner_classname ? this.props.options.style.cookies_inner_classname : 'p-5'}>
            <div className={this.props.options.style.cookies_text_classname ? this.props.options.style.cookies_text_classname : ''}>
              {this.props.placeholder}
            </div>
          </div>
        </div>
      )
    }

    if (this.state.cookieStatus == 'accepted') return this.props.children

    return (
      <div className={this.props.options.style.cookies_classname ? this.props.options.style.cookies_classname : 'text-center bg-light'}>
        <div className={this.props.options.style.cookies_inner_classname ? this.props.options.style.cookies_inner_classname : 'p-5'}>
          <div className={this.props.options.style.cookies_text_classname ? this.props.options.style.cookies_text_classname : ''}>
            {this.props.placeholder}
          </div>
          {/* <button 
            className={this.props.options.style.cookies_clickable_classname ? this.props.options.style.cookies_clickable_classname : 'btn btn-dark'}
            onClick={_ => acceptCookies()}
          >
            {this.props.button ? this.props.button : "Accepteer cookies"}
          </button> */}
        </div>
      </div>
    )
  }
}
